import { ThemeColors, hexToRgbaWithAlpha } from '../theme';

export const FormTheme = {
  DarkSimple: 'FormTheme--DarkSimple',
  DarkOrange: 'FormTheme--DarkOrange',
  DarkOrangeSimple: 'FormTheme--DarkOrangeSimple',
};

export const DARK_BACKGROUND_COLOR = ThemeColors.COLOR_GREY_DARK1_1;
export const DARK_VIEW_BACKGROUND_COLOR = ThemeColors.COLOR_GREY_DARK2;
export const DARK_SIMPLE_PLACEHOLDER_COLOR = hexToRgbaWithAlpha(
  ThemeColors.COLOR_GREY7_1,
  0.5
);
export const ORANGE_PLACEHOLDER_COLOR = hexToRgbaWithAlpha(
  ThemeColors.COLOR_ORANGE1,
  0.5
);

export const ThemeBoxShadowMap = {
  [FormTheme.DarkSimple]: 'none',
  [FormTheme.DarkOrange]: `inset 0 2px 5px ${hexToRgbaWithAlpha(ThemeColors.COLOR_BLACK0_7, 0.5)}`,
  [FormTheme.DarkOrangeSimple]: 'none',
};
